import { PdfIcon } from "components/icons/pdf-icon";
import React from "react";
import { PdfChipContainer } from "./pdf-chip.styles";
import { IPdfChipProps } from "./pdf-chip.types";

const PdfChip: React.FC<IPdfChipProps> = ({ value }) => (
  <PdfChipContainer>
    <PdfIcon /> {value} PDF
  </PdfChipContainer>
);

export { PdfChip };
